export enum StakingInstructions {
  InitStakingPool = 0,
  CreateStakeAccount = 1,
  Deposit = 2,
  Withdraw = 3,
  ClaimReward = 4,
  UpdateEarliestRewardClaimTime = 5,
}
